import { GDPR_COOKIE_NAME } from "../../../../constants";
import { REQUIRED_COUNTRIES } from "../../../../GDPR/GDPRCookieBanner/requiredCountries";

export const consentStatus = (
  cookies: Record<string, unknown>,
): "granted" | "denied" | "pending" => {
  if (
    !Object.hasOwn(REQUIRED_COUNTRIES, window.CLOUDFLARE_COUNTRY_CODE ?? "")
  ) {
    return "granted" as const;
  }

  const isInHouseConsent =
    cookies[GDPR_COOKIE_NAME] === true || cookies[GDPR_COOKIE_NAME] === "true";

  if (isInHouseConsent) return "granted";
  return cookies[GDPR_COOKIE_NAME] !== undefined ? "denied" : "pending";
};
